export default {
  data() {
    return {
      exportResultExcelFields: [
        {
          label: "Name",
          value: "name",
        },

        {
          label: "Case Type",
          value: "case_type",
        },
        {
          label: "Status",
          value: "status",
        },

        {
          label: "Total Samples Count",
          value: "total_samples_count",
        },
        {
          label: "Completed Samples Count",
          value: "completed_samples_count",
        },
        {
          label: "Success Samples Count",
          value: "success_samples_count",
        },
        {
          label: "Failed Samples Count",
          value: "failed_samples_count",
        },
        {
          label: "Uploaded By",
          value: "uploadedBy",
        },
        {
          label: "Created At",
          value: "createdAt",
        },
      ],
    };
  },
};
